module.exports = __webpack_public_path__ + "static/media/Brands_27.f853a330.png";